export default __webpack_public_path__ + "8d1a7efe3e407a27115b13c0e9d80407.png";